<template>
  <div class="h-100 pt-4 pb-1" data-testid="kiosk-main-screen">
    <div class="text-center kiosk-login-auth-box">
      <CCol>
        <h2 class="from-text kiosk-main-heading mb-0">
          {{ $t("kiosk.from") }}
        </h2></CCol
      >
      <CCol class="img-box">
        <img
          class="img"
          :src="
            activeKiosk.user.avatar
              ? activeKiosk.user.avatar
              : '/img/avatars/user-avatar.jpeg'
          "
          :alt="kioskProfilePhotoAlt"
        />
      </CCol>
      <CCol class="kiosk-login-auth-box-text">
        {{ activeKiosk.user.first_name + " " + activeKiosk.user.last_name }} ({{
          activeKiosk.room
            ? activeKiosk.room.name
            : activeKiosk.user
              ? activeKiosk.user.name
              : ""
        }})
      </CCol>
    </div>
    <CRow class="w-auto m-auto mt-3">
      <BaseButton
        data-test-id="kiosk-new-pass-button"
        class="d-flex align-items-center justify-content-center"
        solid
        rounded
        @click="setActiveTab('createPass')"
      >
        {{ $t("kiosk.new_pass") }}
      </BaseButton>
    </CRow>
    <CRow class="w-auto m-auto mt-3">
      <BaseButton
        data-test-id="kiosk-end-pass-button"
        class="d-flex align-items-center justify-content-center"
        rounded
        @click="setActiveTab('endPass')"
      >
        {{ $t("kiosk.end_pass") }}
      </BaseButton>
    </CRow>
    <div v-if="activePassErrorMessage">
      <InfoBox
        class="my-4"
        :class="{ danger: !!activePassErrorMessage }"
        :announce-assertive="!!activePassErrorMessage"
        :message="activePassErrorMessage"
        data-testid="kiosk-main-screen-active-pass-error"
      />
      <p class="mt-0 px-1">
        <button
          type="button"
          class="kiosk-close-msg-btn"
          data-testid="kiosk-main-screen-go-to-login"
          @click="goToLogin()"
        >
          {{ $t("kiosk.or_click_here_to_close_it_now") }}
        </button>
      </p>
    </div>
    <div class="d-flex align-items-center justify-content-center mt-5">
      <a
        class="kiosk-terms-and-privacy-text"
        target="_blank"
        href="https://www.securly.com/terms-and-conditions"
        >{{ $t("kiosk.terms_of_use") }}</a
      >
      <span class="mx-2">|</span>
      <a
        class="kiosk-terms-and-privacy-text"
        target="_blank"
        href="https://www.securly.com/privacy"
        >{{ $t("kiosk.privacy_policy") }}</a
      >
    </div>
  </div>
</template>
<script>
import { computed, ref } from "vue"
import { useStore } from "vuex"
import { useI18n } from "vue-i18n"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import InfoBox from "@/v3components/shared/Alerts/InfoBox.vue"

export default {
  name: "KioskMainScreen",

  components: { BaseButton, InfoBox },

  props: {
    activeKiosk: {
      type: Object,
      required: true
    }
  },

  emits: ["tabChanged"],

  setup(props, { emit }) {
    const store = useStore()
    const { t } = useI18n()

    const activePassErrorMessage = ref(null)

    const activePass = computed(() => store.getters["kiosks/activePass"])

    const kioskProfilePhotoAlt = computed(() => {
      const user = props.activeKiosk?.user
      if (!user) return t("kiosk.a11y_profile_photo")
      const name = [user.first_name, user.last_name]
        .filter(Boolean)
        .join(" ")
        .trim()
      return name
        ? t("kiosk.a11y_profile_photo_named", { name })
        : t("kiosk.a11y_profile_photo")
    })

    const setActiveTab = (tab) => {
      if (tab === "createPass" && activePass.value) {
        activePassErrorMessage.value = t(
          "kiosk.the_student_already_has_an_active_pass"
        )
        return
      }

      activePassErrorMessage.value = null
      emit("tabChanged", tab)
    }

    const goToLogin = () => {
      activePassErrorMessage.value = null
      store.dispatch("kiosks/userLogout")
      emit("tabChanged", "userLogin")
    }

    return {
      activePassErrorMessage,
      kioskProfilePhotoAlt,
      setActiveTab,
      goToLogin
    }
  }
}
</script>
